<template>
  <component
    :is="component"
    class="dppl-svg"
    :data-file-name="fileName"
    :style="{ color }"
  />
</template>

<script>
import { h, defineAsyncComponent } from 'vue';

export default {
  name: 'DpplSvg',
  props: {
    fileName: { type: String, default: '' },
    color: { type: String, default: '' },
  },
  computed: {
    component() {
      // Use stub component in test environment
      if (import.meta.env.NODE_ENV === 'test') {
        return this.stubComponent;
      }

      if (!this.fileName) {
        return null;
      }

      // vite has restrictions on dynamic imports with variables,
      // it can only handle variables that represent file names "one level deep"
      if (this.fileName.startsWith('icons/')) {
        return defineAsyncComponent(() => import(`@/assets/icons/${this.fileName.replace('icons/', '')}.svg?component`));
      }

      if (this.fileName.startsWith('platform/')) {
        return defineAsyncComponent(() => import(`@/assets/platform/${this.fileName.replace('platform/', '')}.svg?component`));
      }

      if (this.fileName.startsWith('articles/')) {
        return defineAsyncComponent(() => import(`@/assets/articles/${this.fileName.replace('articles/', '')}.svg?component`));
      }

      if (this.fileName.startsWith('ats/')) {
        return defineAsyncComponent(() => import(`@/assets/ats/${this.fileName.replace('ats/', '')}.svg?component`));
      }

      // eslint-disable-next-line import/no-dynamic-require, global-require
      return defineAsyncComponent(() => import(`@/assets/${this.fileName}.svg?component`));
    },
    // tests can't load svg?inline, this is replacement component
    stubComponent() {
      return {
        render: () => h('div', { attrs: { 'data-file-name': this.fileName } }),
      };
    },
  },
};
</script>
